import { Stack, Typography } from '@mui/material';

import { EllipsisTooltip } from '@/components';

interface PropertyTypeRowProps {
  label: string;
  value: string;
  index?: number;
}

const PropertyTypeCell = ({ label, value }: PropertyTypeRowProps) => {
  return (
    <Stack
      sx={{
        py: 2,
        pl: 0,
      }}
    >
      <Typography variant="inherit" sx={{ fontWeight: 600, fontSize: '14px' }}>
        {label}
      </Typography>
      {value ? (
        <EllipsisTooltip sx={{ fontSize: '14px' }}>{value}</EllipsisTooltip>
      ) : (
        ''
      )}
    </Stack>
  );
};

export default PropertyTypeCell;
